import DatePicker from "react-datepicker2";
import { useForm } from "react-hook-form";
import "react-datepicker2/src/styles/style.css";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useRef, useState } from "react";
import BihamtaTable from "../Components/BihamtaTable";
import { searchSentSMS } from "../BaseInfo/store/api/SMSApi";
import { useEffect } from "react";
import { Search } from "react-bootstrap-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSms } from "@fortawesome/free-solid-svg-icons";
const SearchSentSMS = () => {
    const searchData = useRef({});
    const [smsList, getList] = useState([]);
    const { handleSubmit, register } = useForm();
    const tableRowButtons = [];
    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "تاریخ ارسال", colName: "PSendDate", showInMobile: true },
        { colTitle: "شماره همراه", colName: "TargetNumber", showInMobile: true },
        { colTitle: "متن پیامک", colName: "SmsBody", showInMobile: true, colType: "string", maxLength: 250, hasTooltip: true },
    ]
    function search(data) {
        searchData.current.Skip = 0;
        Object.assign(searchData.current, data);
        const dFrom = document.getElementsByName("DateFrom")[0].value;
        const dTo = document.getElementsByName("DateTo")[0].value;
        if (dFrom === "") {
            searchData.current.DateFrom = null;
        }
        if (dTo === "") {
            searchData.current.DateTo = null;
        }
        searchSentSMS(searchData.current, getList);
    }
    useEffect(() => {
        document.body.classList = "notMain";
    }, [])
    return (
        <div className="container-fluid mt-1">
            <br />
            <Card>
                <Card.Header className="headerStyle"><FontAwesomeIcon icon={faSms} size="lg"/>&nbsp;جستجوی پیامکهای ارسالی</Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right", minHeight: "45vh" }}>
                    <form readOnly onSubmit={handleSubmit(search)}>
                        <Row className="rowBorder">
                            <Col md={2} className="form-group">
                                <label>از تاریخ:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="DateFrom"
                                    onChange={val => searchData.current.DateFrom = val.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تا تاریخ:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="DateTo"
                                    onChange={val => searchData.current.DateTo = val.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>شماره همراه</label>
                                <Form.Control name="TargetNumber" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>متن پیامک</label>
                                <Form.Control name="SmsBody" ref={(register({}))} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تعداد در صفحه</label>
                                <select className="form-control" name="Take" ref={register({})} defaultValue={10}>
                                    <option value={0}>انتخاب کنید</option>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                    </select>
                            </Col>
                        </Row>
                        <Button className="group-Btn-large mt-1" type="submit"><Search size={15} />&nbsp;جستجوی پیامک ها</Button>
                    </form>
                    <BihamtaTable columns={tableColes} rowButtons={tableRowButtons} filterData={searchData.current}
                        searchMethod={searchSentSMS} dataList={smsList} hasPaging={true}/>
                </Card.Body>
            </Card>
        </div>
    )
}
export default SearchSentSMS;